<template>
  <div data-component-group="header-layout" data-component="logged">
    <Header>
      <div style="display: flex; align-items: center">
        <v-btn
          v-if="backUrl"
          icon
          plain
          color="black"
          :ripple="false"
          @click="onBackClick"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>

        <h1>
          {{ title }}
        </h1>
      </div>

      <div class="header-layout__actions">
        <slot />
      </div>
    </Header>
  </div>
</template>

<script>
  import Header from './Header';

  export default {
    components: {
      Header,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      backUrl: {
        type: String,
        default: '',
      },
    },
    methods: {
      onBackClick() {
        this.$emit('beforeGoBack');
        this.$router.push(this.backUrl);
        this.$emit('afterGoBack');
      },
    },
  };
</script>

<style lang="scss">
@import '../../../assets/styles/theme';

[data-component-group='header-layout'][data-component='logged'] {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  h1 {
    font-size: 24px;
  }
}

.header-layout__actions {
  display: flex;
  gap: 16px;
}
</style>
